'use strict';
import {createActions} from 'client/framework';

const normalActions = ['SET_ACTIVE_SUBJECT_ID'];

const upgradeCallToActionModalActions = createActions(null, normalActions);
export default upgradeCallToActionModalActions;
